import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import PropTypes from 'prop-types';
import Search from '../header/Search';
import ProfileOneIcon from '../svg/ProfileOneIcon';
import ReorderIcon from '../svg/ReorderIcon';
import UserMenu from './UserMenu';
import Link from '@/components/common/Link';
// import { restoreLastOrder } from '@/utils/orderUtils';

function TopMenu({ items, color }) {
  const [isClient, setIsClient] = useState(false);
  // const [isRestoring, setIsRestoring] = useState(false);
  const t = useTranslations('Account');

  useEffect(() => {
    setIsClient(true);

    const handleStorageChange = (e) => {
      if (e.key === 'token' && !e.newValue) {
        localStorage.removeItem('userData');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const isLoggedIn = isClient ? !!localStorage.getItem('token') : false;

  return (
    <div className="flex justify-between items-center h-2/5">
      <div className="flex items-center min-w-max">
        <Search />
      </div>
      <nav className="flex items-center justify-center h-1/2 min-w-max">
        <ul className="flex space-x-2 xl:space-x-4 font-semibold text-primary-studio text-sm xl:text-base">
          {items.map((item) => (
            <li key={`${item.url}-${item.title}`} className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
              <Link href={item.url} className="flex items-center hover:underline whitespace-nowrap">
                {item.image_url && (
                  <Image src={item.image_url} alt={item.title} width={32} height={32} className="mr-2 hidden md:block" />
                )}
                {item.title}
              </Link>
            </li>
          ))}
          <li className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
            {isLoggedIn ? (
              <UserMenu color={color} />
            ) : (
              <Link href="/login" className="hover:underline whitespace-nowrap">
                <span className="hidden md:inline">{t('login')}</span>
                <ProfileOneIcon width="24px" fill={color} className="inline ms-1 h-4 w-4 xl:h-6 xl:w-6" />
              </Link>
            )}
          </li>
          <li className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
            {isLoggedIn ? (
              // <button
              //   onClick={() => restoreLastOrder(setIsRestoring)}
              //   disabled={isRestoring}
              //   className="flex items-center hover:text-primary-studio/80 transition-colors"
              //   title={t('restore_last_order')}
              // >
              //   <ReorderIcon width={20} height={20} color={color} className="inline me-1" />
              //   <span className="ml-2 hidden md:inline whitespace-nowrap">
              //     {isRestoring ? t('restoring') : t('restore_last_order')}
              //   </span>
              // </button>
              <Link
                href="/my-account?tab=my-orders"
                className="flex items-center hover:text-primary-studio/80 transition-colors"
              >
                <ReorderIcon width={20} height={20} color={color} className="inline me-1 h-4 w-4 xl:h-6 xl:w-6" />
                <span className="ml-2 hidden md:inline whitespace-nowrap">
                  {/* {isRestoring ? t('restoring') : t('restore_last_order')} */}
                  {t('restore_last_order')}
                </span>
              </Link>
            ) : (
              <Link href="/my-account?tab=my-orders" className="hover:underline whitespace-nowrap">
                <ReorderIcon width={20} height={20} color={color} className="inline me-1 h-4 w-4 xl:h-6 xl:w-6" />
                <span className="ml-2 hidden md:inline whitespace-nowrap">
                  {/* {isRestoring ? t('restoring') : t('restore_last_order')} */}
                  {t('restore_last_order')}
                </span>
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </div>
  );
}

TopMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image_url: PropTypes.string,
  })).isRequired,
  color: PropTypes.string.isRequired,
};

export default TopMenu;
